import ActionsForm from '@/shared/mixins/actionsForm'
// import { loading, toast } from '@/shared/utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'
export default {
  name: 'collapseApr',
  mixins: [ActionsForm, PermissionMixin],
  components: {},
  data () {
    return {

    }
  },

  props: {
    formAdd: {
      type: Object,
      requered: false
    },
    categoriaNomeAdd: {
      type: String,
      required: null
    }
  },

  watch: {
  },

  mounted () {
  },
  methods: {
    cancel () {
      this.formAdd = {}
      this.formAdd.descricao = null
      this.fechaPopAtualizaGrid = !this.fechaPopAtualizaGrid
      this.$emit('fechaPopAtualizaGrid', this.fechaPopAtualizaGrid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/registerApr/components/collapseapr/components/collapseAddApr/collapseAddApr.js